import { resourceText } from 'src/app/shared/services/localization';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';

export type FieldMode = 'required' | 'optional' | 'hidden';
export const profileFieldDefaults: Record<string, FieldMode> = {
  street: 'required', city: 'required', state: 'required', zip: 'required', country: 'required',
  dateOfBirth: 'required', gender: 'required', maritalStatus: 'optional', occupation: 'optional', email: 'optional',
  language: 'optional', picture: 'optional'
};
export const profileFieldSections = [
  { get title() { return resourceText('ADDRESS'); }, fields: ['street', 'city', 'state', 'zip', 'country'] },
  { get title() { return resourceText('PERSONAL_DETAILS'); }, fields: ['dateOfBirth', 'gender', 'maritalStatus', 'occupation', 'picture'] },
  { get title() { return resourceText('CONTACT_PREFERENCES'); }, fields: ['email', 'language'] }
];
export const profileFieldLabels = {
  get street() { return resourceText('STREET'); }, get city() { return resourceText('CITY'); }, get state() { return resourceText('STATE'); }, get zip() { return resourceText('ZIP'); }, get country() { return resourceText('COUNTRY'); },
  get dateOfBirth() { return resourceText('DATE_OF_BIRTH'); }, get gender() { return resourceText('GENDER'); }, get maritalStatus() { return resourceText('MARITAL_STATUS_98D0D2F'); }, get occupation() { return resourceText('OCCUPATION'); }, get picture() { return resourceText('PROFILE_PICTURE'); },
  get email() { return resourceText('EMAIL'); }, get language() { return resourceText('PREFERRED_LANGUAGE'); }
};
export function readProfilePolicy(json?: string, tenant?: string): Record<string, FieldMode> {
  const result = { ...profileFieldDefaults };
  // The shared test tenant always keeps configurable profile details optional.
  if (tenant?.trim().toLowerCase() === 'test') { Object.keys(result).forEach(key => result[key] = 'optional'); return result; }
  try {
    const saved = JSON.parse(json || '{}');
    Object.keys(result).forEach(key => {
      if (['required', 'optional', 'hidden'].includes(saved?.[key])) result[key] = saved[key];
    });
  } catch { /* Existing churches use the defaults until settings are saved. */ }
  return result;
}
const policyDisabled = new WeakSet<AbstractControl>();
export function applyProfilePolicy(form: FormGroup, policy: Record<string, FieldMode>) {
  Object.keys(profileFieldDefaults).forEach(key => {
    const control = form.get(key);
    if (!control) return;
    const mode = policy[key] || profileFieldDefaults[key];
    control.removeValidators(Validators.required);
    if (mode === 'required') control.addValidators(Validators.required);
    if (mode === 'hidden' && control.enabled) {
      control.disable({ emitEvent: false });
      policyDisabled.add(control);
    } else if (mode !== 'hidden' && policyDisabled.has(control)) {
      control.enable({ emitEvent: false });
      policyDisabled.delete(control);
    }
    control.updateValueAndValidity({ emitEvent: false });
  });
}
